import { Provider } from 'react-redux';
import './App.css';

import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import store from './redux/store';

function App() {
  return (
    <Provider store={store}>
      <Navbar />
      <HomePage />
    </Provider>
  );
}

export default App;
